// constants.ts

export const NAME = 'homePage';